/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ArticleTeaser/Bodytext/theme';

export const ArticleTeaserBodytextTheme = theme;
